<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12"
             :class="{ 'navigation-disabled': isNavigationDisabled }"
             @click.capture="containerClick">
        <stepper />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-3 ml-5"
             cols="12"
             v-if="!isNavigationDisabled">
        <span>{{ $t('navigation.desc') }}</span>
      </v-col>
      <v-col class="pa-3"
             cols="12"
             v-if="!isNavigationDisabled">
        <summary-dialog />
      </v-col>      
      <v-col class="pa-3"
             cols="12">
        <contract-viewer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Stepper from './Stepper.vue'
  import Summary from './Summary.vue'
  import ContractViewer from '../views/ContractViewer.vue'

  export default {
    components: {
      'stepper': Stepper,
      'summary-dialog': Summary,
      'contract-viewer': ContractViewer
    },
    computed: {
      isNavigationDisabled () {
        return this.$store.getters.isNavigationDisabled
      }
    },
    methods: {
      containerClick (e) {
        if (this.isNavigationDisabled) {
          e.stopPropagation()
        }
      }
    }
  }
</script>

<style>
    .navigation-disabled, .navigation-disabled * {
        cursor: not-allowed !important;
    }

    .v-application .v-stepper__step--complete .v-stepper__step__step {
        background-color: #4caf50 !important;
        border-color: #4caf50 !important;
    }

    .v-stepper.registration-stepper {
        background: transparent;
    }

    .v-stepper.registration-stepper .v-stepper__label {
        cursor: pointer;
    }

    .tree, .tree ul {
        margin: 0;
        padding: 0;
        list-style: none
    }

    .tree ul {
        margin-left: 1em;
        position: relative;
    }

    .tree ul:before {
        content: "";
        display: block;
        width: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        border-left: 1px solid
    }

    .tree li {
        padding: 0 1em;
        position: relative;
        line-height: 2em;
    }

    .tree > li {
        padding-left: 0;
    }

    .tree ul li:before {
        content: "";
        display: block;
        width: 10px;
        height: 0;
        border-top: 1px solid;
        margin-top: 3px;
        position: absolute;
        top: 1em;
        left: 0
    }

    .tree ul li:last-child:before {
        background: #f2f3f5;
        top: 1em;
        bottom: 0;
        height: auto;
    }

    .tree {
        margin-bottom: 0.25em;
    }
    .v-stepper__wrapper .tree:last-child {
        margin-bottom: 0;
    }

    .custom-stepper-content {
        margin: -8px -36px -16px 36px;
        padding: 0 60px 0 36px;
        width: auto;
        border-left: 1px solid rgba(0, 0, 0, 0.12);
        min-height: 32px;
    }

    .clickable {
        cursor: pointer;
        font-size: 0.85rem;
    }
    .clickable:hover, .clickable.router-link-active {
        font-weight: bolder;
    }

    .sidebar-content {

    }
    .sidebar-content.fixed {
        position: fixed;
        width: 100%;
    }
    .sidebar-content.fixed.fixed-top {
        top: 0;
    }
    .sidebar-content.fixed.fixed-bottom {
        bottom: 0;
    }
</style>
